import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const patients = [
  {
    path: '/vector/patients',
    name: 'vector-patients-home',
    component: () => import('@/pages/vector/patients/PatientsListPage.vue'),
    meta: {
      title: 'Patients',
      resource: 'Vector',
      action: 'read',
      subject: 'Patient',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/patients/:patient_uuid',
    name: 'vector-patients-patient-details',
    component: () => import('@/pages/vector/patients/PatientDetailPage.vue'),
    meta: {
      title: 'Patient Details',
      resource: 'Vector',
      action: 'read',
      subject: 'Patient',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/patients/:patient_uuid/:enrollment_uuid',
    name: 'vector-patients-patient-details-enrollment',
    component: () => import('@/pages/vector/patients/enrollment.vue'),
    meta: {
      title: 'Patient Enrollment',
      resource: 'Vector',
      action: 'read',
      subject: 'Patient',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/patients/:patient_uuid/consents/:consent_uuid',
    name: 'vector-patients-patient-details-consent',
    component: () => import('@/pages/vector/patients/consent.vue'),
    meta: {
      title: 'Patient Consent',
      resource: 'Vector',
      action: 'read',
      subject: 'Patient',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default patients
